import React, { Component, cloneElement } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { hideModal, resetModal } from 'redux/modules/modal';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const styles = theme => ({
	modal: {},
	content: { 
		marginBottom: 40
	},
	contentText: {
		opacity: 1,
		color: '#000',
		textAlign: 'left'
	},
	/* Dialog */
	dialogPaper: {
		minWidth: 444
	},
	dialogWrapper: {
		position: 'relative',
		padding: '15px 10px 15px'
	},
	dialogTitle: {
		'& h6': {
			fontWeight: 600,
			fontSize: '28px',
			lineHeight: 1.4,
			marginBottom: 6,
			textAlign: 'left'
		}
	},
	dialogActions: {
	},
	/* buttons */
	button: {
		fontFamily: 'Open Sans, sans-serif',
		borderRadius: 5,
		fontWeight: 600,
		fontSize: 18,
		lineHeight: 1.3,
		color: '#000',
		opacity: '1 !important',
		paddingLeft: 15,
		paddingRight: 15,
		minWidth: 100
	},
	buttonCancel: {
	},
	buttonConfirm: {
		background: theme.palette.primary.main,
		color: 'white',
		textShadow: 'none',
		'&[class*=contained][class*=disabled]': {
			backgroundColor: '#B3B9C0'
		},
		marginLeft: 10
	},
	/* error message */
	errorMessage:  {
		color: theme.palette.error.main,
		fontSize: 14,
		lineHeight: 1.5,
		opacity: 1,
		textAlign: 'left',
		marginTop: 0,
		marginBottom: 15
	}
});

@withStyles(styles)
class ConfirmationModal extends Component {

	render() {
		const { classes, modalShown, resetModal, title } = this.props;

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
				BackdropProps={{ style: { backgroundColor: 'rgba(46, 63, 79, 0.4)' } }}
				classes={{ paper: classes.dialogPaper }}
				PaperProps={{
					style: {
						border: 0,
						width: 309,
						borderRadius: 5,
						boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)'
					}
				}}
			>
				<div className={classes.dialogWrapper}>
					{title &&
						<DialogTitle
							variant='body1'
							color='default'
							className={classes.dialogTitle}>{title}
						</DialogTitle>}
					{this.renderContent()}
					<DialogActions className={classes.dialogActions}>
						<Grid item container direction="row" justify="flex-end">{this.renderButtons()}</Grid>
					</DialogActions>
				</div>
			</Dialog>
		);
	}

	renderContent() {
		let contentText;
		const { message, classes } = this.props;

		if (message && message.__html) {
			contentText = (<DialogContentText 
				dangerouslySetInnerHTML={message} 
				variant='body1'
				color='default'
				className={classes.contentText} />);
		} else {
			contentText = (<DialogContentText
				variant='body1'
				color='default'
				className={classes.contentText}>{message}</DialogContentText>);
		}

		return (
			<DialogContent className={classes.content}>
				{this.renderErrorMessage()}
				{contentText}
			</DialogContent>
		);
	}

	renderErrorMessage() {
		const { classes } = this.props;
		if (this.props.showCouponErrorMessageIfExists &&
			(this.props.discount.couponCodeInvalidReason || this.props.discount.couponCodeFetchErrorId)) {
			return (
				<Typography
					className={classes.errorMessage}
					variant="body2"
					dangerouslySetInnerHTML={{ __html: localize('subscriptions-error-reduce-users-invalid-coupon') }} />
			);
		}
	}

	renderButtons() {
		const { hideModal, buttons, hideModalOnButtonClick, classes } = this.props;
		return buttons.map((button, index) => {
			return (<Grid item key={`confirmation-modal-button-${index}`}>
				{cloneElement(button, {
					className: index === 0 && buttons.length > 1
						?
						classNames(classes.button, classes.buttonCancel)
						:
						classNames(classes.button, classes.buttonConfirm),
					onClick: () => {
						hideModalOnButtonClick && hideModal();
						button.props.onClick && button.props.onClick();
					}
				})}
			</Grid>);
		});
	}
}

ConfirmationModal.defaultProps = {
	buttons: [],
	hideModalOnButtonClick: true
};

ConfirmationModal.propTypes = {
	classes: PropTypes.object,
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	title: PropTypes.string,
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	buttons: PropTypes.array,
	hideModalOnButtonClick: PropTypes.bool,
	discount: PropTypes.object.isRequired,
	showCouponErrorMessageIfExists: PropTypes.bool
};

const mapStateToProps = state => ({
	modalShown: state.modal.modalShown,
	discount: state.discount
});

const mapDispatchToProps = dispatch => bindActionCreators({
	hideModal,
	resetModal
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ConfirmationModal);


// WEBPACK FOOTER //
// ./src/components/Modal/ConfirmationModal.js